<div class="page-wrapper" [ngClass]="{ haptic: this.config.modalities[0].active }">
  <div class="page-section start" [ngClass]="{ darkMode: this.config.theme === 'dark-mode'}">

    <div class="section-header" [ngClass]="{ haptic: this.config.modalities[0].active }">
      <div class="section-title" [ngClass]="{ darkMode: this.config.theme === 'dark-mode'}">Teaching</div>
    </div>

    <ul class="course-list">
      <li class="course-item" *ngFor="let item of this.courses" [ngClass]="{ haptic: this.config.modalities[0].active }">
        <p class="body-title">{{ item?.course }}</p>
        <div class="inline-text" *ngIf="item.description && item.level">
          <p class="publication-type" *ngIf="item.level">{{ item?.level }}</p><br />
          <p class="body-text" *ngIf="item.description">{{ item?.description }}</p><br />
        </div>
        <span *ngIf="item?.url" class="buttonEl site-explanation" (click)="linkTo(item?.url)">Learn more
          <div class="arrow-link explanation" [ngClass]="{ hovereffect: this.config.modalities[1].active }"></div>
        </span>
      </li>
    </ul>

  </div>

  <app-footer></app-footer>
</div>
